//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
        }
    },
    created () {
    },
    mounted () {
    },
    watch : {
    },
    methods: {
       
    }
}



// WEBPACK FOOTER //
// ./src/plugins/pl_message/template.vue